import type { ExamComparison } from '@/lib/scoreTrend';
import ScoreDeltaBadge from './ScoreDeltaBadge';

export default function ScoreCompareTable({ comparison }: { comparison: ExamComparison }) {
  const { currentLabel, previousLabel, rows, avgCurrent, avgPrevious, avgDelta } = comparison;

  return (
    <div className="rounded-lg bg-background-50 p-3 md:p-4">
      <div className="flex flex-wrap items-center justify-between gap-2">
        <p className="flex items-center gap-1.5 text-xs font-semibold text-foreground-700">
          <i className="ri-arrow-left-right-line text-secondary-600"></i>
          이전 시험 대비
        </p>
        <p className="text-[11px] text-foreground-500">
          {previousLabel ? (
            <>
              <span className="text-foreground-400">{previousLabel}</span>
              <i className="ri-arrow-right-line mx-1 align-middle"></i>
              <span className="font-semibold text-foreground-800">{currentLabel}</span>
            </>
          ) : (
            <span className="font-semibold text-foreground-800">{currentLabel}</span>
          )}
        </p>
      </div>

      {!previousLabel ? (
        <p className="mt-3 rounded-md border border-dashed border-background-300 py-6 text-center text-xs text-foreground-500">
          비교할 이전 시험이 아직 없어요. 다음 시험을 입력하면 변화가 보여요.
        </p>
      ) : (
        <>
          <div className="mt-3 grid grid-cols-[1fr_3rem_3rem_4rem] gap-2 border-b border-background-200 pb-1.5 text-[11px] font-semibold text-foreground-500 sm:grid-cols-[1fr_3.5rem_3.5rem_4.5rem]">
            <span>과목</span>
            <span className="text-right">이전</span>
            <span className="text-right">현재</span>
            <span className="text-center">변화</span>
          </div>

          <div className="divide-y divide-background-200">
            {rows.map((r) => (
              <div
                key={r.subject}
                className="grid grid-cols-[1fr_3rem_3rem_4rem] items-center gap-2 py-2 sm:grid-cols-[1fr_3.5rem_3.5rem_4.5rem]"
              >
                <span className="truncate text-sm font-medium text-foreground-900">
                  {r.subject}
                </span>
                <span className="text-right text-sm text-foreground-500">
                  {r.previous === null ? '—' : r.previous}
                </span>
                <span className="text-right text-sm font-bold text-foreground-950">
                  {r.current}
                </span>
                <span className="flex justify-center">
                  <ScoreDeltaBadge delta={r.delta} />
                </span>
              </div>
            ))}
          </div>

          <div className="mt-2 grid grid-cols-[1fr_3rem_3rem_4rem] items-center gap-2 rounded-md bg-secondary-100/70 px-2 py-2 text-sm sm:grid-cols-[1fr_3.5rem_3.5rem_4.5rem]">
            <span className="font-semibold text-secondary-900">평균</span>
            <span className="text-right text-secondary-900">{avgPrevious ?? '—'}</span>
            <span className="text-right font-bold text-secondary-900">{avgCurrent ?? '—'}</span>
            <span className="flex justify-center">
              <ScoreDeltaBadge delta={avgDelta} />
            </span>
          </div>
        </>
      )}
    </div>
  );
}